import type { ReactNode } from 'react';
import { Box, Typography, type SxProps, type Theme } from '@mui/material';
import { composeSx } from '../../utils/composeSx';

export type HFControlGroupProps = {
  label?: ReactNode;
  children: ReactNode;
  sx?: SxProps<Theme>;
};

export function HFControlGroup({ label, children, sx }: HFControlGroupProps) {
  const labeled = label != null && label !== '';
  return (
    <Box
      sx={composeSx(
        {
          position: 'relative',
          display: 'inline-flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1,
          px: 1.5,
          pt: labeled ? 1.5 : 1.25,
          pb: 1,
          minHeight: 40,
          border: 1,
          borderColor: (theme) => (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.45)' : 'rgba(15,23,41,0.32)'),
          borderRadius: 1,
          bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#1a2748' : '#fff'),
          maxWidth: '100%',
        },
        sx,
      )}
    >
      {labeled ? (
        <Typography
          component="span"
          sx={{
            position: 'absolute',
            top: 0,
            left: 12,
            px: 0.5,
            transform: 'translateY(-50%)',
            fontSize: 12,
            lineHeight: 1,
            fontWeight: 400,
            letterSpacing: '0.00938em',
            color: 'text.secondary',
            bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#1a2748' : '#fff'),
          }}
        >
          {label}
        </Typography>
      ) : null}
      {children}
    </Box>
  );
}
